// extracted by mini-css-extract-plugin
export default {"input_main":"EditVideo_input_main__xFLdt","heading":"EditVideo_heading__obI7V","main":"EditVideo_main__i1vaB"};